import httpService from "..";

export const searchMembersApi = async (groupId: string, search: string) => {
  // Backend: GET /member/group/:groupId/search/:search (getSearchGroupMembers)
  const term = encodeURIComponent(String(search).trim());
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/group/${groupId}/search/${term}`,
    "get"
  );
};

export const getMembersApi = async () => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member`,
    "get"
  );
};

export const getMemberApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/${id}`,
    "get"
  );
};

export const getCompanyMembersApi = async (groupId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/group/${groupId}`,
    "get"
  );
};

export const getMemberPolicyApi = async (num?: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/policy?number=${num}`,
    "get"
  );
};

export const addMemberApi = async (data: {}, userId: number, policyUserId?: number) => {
  const url = policyUserId 
    ? `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member?userId=${userId}&policyUserId=${policyUserId}`
    : `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member?userId=${userId}`;
  return await httpService(
    url,
    "post",
    data
  );
};

export const addContinuationMemberApi = async (
  id: string,
  data: any,
  userId: any,
  claimId: any
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/${id}/continuation-policy?userId=${userId}&claimId=${claimId}`,
    "post",
    data
  );
};

export const getMemberDigitalApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/digital/${id}`,
    "get"
  );
};

export const getDigitalApplicationApi = async (id: string, appDoc: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/digital-application/${id}?appDoc=${appDoc}`,
    "get"
  );
};

export const sendMemberApplicationApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/send/${id}`,
    "post"
  );
};

export const authenticateMemberApi = async (id: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/authenticate/${id}`,
    "post",
    data
  );
};

export const authenticateMemberOTPApi = async (id: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/otp/${id}`,
    "post",
    data
  );
};

export const addMemberSignatureApi = async (
  id: string,
  appDoc: string,
  data: any
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/signature/${id}?appDoc=${appDoc}`,
    "post",
    data
  );
};

export const lapseMemberPolicyApi = async (
  id: string,
  data: any,
  userId: any
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/${id}/lapse-policy?userId=${userId}`,
    "post",
    data
  );
};

export const loadMemberPremiumApi = async (id: string, userId: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/${id}/add-premium?userId=${userId}`,
    "post",
    {}
  );
};

export const activateMemberPolicyApi = async (
  id: string,
  data: any,
  userId: any
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/${id}/activate-policy?userId=${userId}`,
    "post",
    data
  );
};

export const sendMemberSmsApi = async (id: string, data: any, userId: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/${id}/send-sms?userId=${userId}`,
    "post",
    data
  );
};

export const editMemberApi = async (id: string, data: any, userId: any, policyUserId?: number) => {
  const url = policyUserId 
    ? `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/${id}?userId=${userId}&policyUserId=${policyUserId}`
    : `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/${id}?userId=${userId}`;
  return await httpService(
    url,
    "patch",
    data
  );
};

export const removeMemberApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/member/${id}`,
    "delete"
  );
};
